import React from "react"
import "./getjobs.css"

function AddVisitDate() {
  return (
    <React.Fragment>
      <h4 className="pt-2">Add visit date</h4>

      <div className="row">
        <div className="col-8">
          <p className="pt-2">Adds an actual visit date for a job.</p>

          <p>
            Visit dates can only be applied to jobs which do not already have a
            visit date set.
          </p>
          <p>
            A <code>date/time</code> is required which represents when the
            engineer started the job, followed by a <code>minutesOnSite</code>{" "}
            which represents how long the job took
          </p>

          <div className="alert alert-warning" role="alert">
            <span className="badge text-bg-warning">PUT</span>{" "}
            <span className="ps-2">
              <code>
                /api/addvisitdate/:workRequestId/:dateTime/:minutesOnSite
              </code>
            </span>
          </div>
          <h4>Security</h4>

          <div className="alert alert-light" role="alert">
            API Key
            <p>
              <code>Authorization</code> and <code>ClientKey</code> keys are
              required in the header. See Authentication
            </p>
          </div>

          <h4>Parameters</h4>

          <div className="alert alert-light" role="alert">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Parameter</th>
                  <th scope="col">Description</th>
                  <th scope="col">Parameter Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <code>
                      <b className="text-dark">workRequestId</b>
                    </code>
                  </th>
                  <td>
                    <code className="text-dark">
                      The workRequestId of the job relating to the message
                    </code>
                  </td>
                  <td>
                    {" "}
                    <code className="text-dark">path</code>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <code className="text-dark">dateTime</code>
                  </th>
                  <td>
                    <code className="text-dark">
                      date formatted yyyy-MM-ddTHH:mm:ss
                    </code>
                    <br />
                    <code className="text-dark">example</code>{" "}
                    <code>2023-12-01T14:05:00</code>
                  </td>
                  <td>
                    <code className="text-dark">path</code>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <code className="text-dark">minutesOnSite</code>
                  </th>
                  <td>
                    <code className="text-dark">number between 1 - 480</code>
                  </td>
                  <td>
                    <code className="text-dark">path</code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="card text-bg-light mb-3">
            <div className="alert alert-success pb-2 pt-2" role="alert">
              <h5>
                {" "}
                <span className="largefont"> &#8226;</span> 200
              </h5>
            </div>

            <div className="card-body">Success</div>
          </div>
        </div>
        <div className="col-4">
          <div className="alert alert-light" role="alert">
            <section>
              <code>
                curl --location --request PUT
                'http://localhost:8080/api/addvisitdate/:workRequestId/dateTime/:minutesOnSite'
                \ --header 'Authorization: AUTH_KEY' \ --header 'ClientKey:
                CLIENT_KEY'
              </code>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
export default AddVisitDate
